export default "__VITE_ASSET__BkU$bh9y__"